import { render, staticRenderFns } from "./PMStructureMovingModal.vue?vue&type=template&id=2b75144c&"
import script from "./PMStructureMovingModal.vue?vue&type=script&lang=ts&"
export * from "./PMStructureMovingModal.vue?vue&type=script&lang=ts&"
import style0 from "./PMStructureMovingModal.vue?vue&type=style&index=0&id=2b75144c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports